import { useTranslation } from "react-i18next";
import styles from "./MyTasks.module.scss";

const MyTasksTitle: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.myInboxTitle}>
      <h2>{t("publication")} <strong>{t("publicationHUB")}</strong></h2>
      <h3>{t("myTasks")}</h3>
    </div>
  );
};

export default MyTasksTitle;
